<template>
  <div class="tw-flex tw-space-x-4">
    <NavLinkIcon v-for="(action, index) in actions" :key="index" :item="action" :testId="testId" />
  </div>
</template>

<script>
import NavLink from "@/classes/NavLink";
import NavLinkIcon from "@/components/display/NavLinkIcon.vue";

export default {
  name: "ActionIcons",
  props: {
    testId: String,
    actions: {
      type: Array,
      validator: (actions) => {
        let valid = true;
        actions.forEach((action) => {
          if (!(action instanceof NavLink)) valid = false;
        });
        return valid;
      },
    },
  },
  components: {
    NavLinkIcon,
  },
};
</script>
